import "./HeroSection.css";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <div className="hero-section">
      <div className="txt-div">
        <div className="header-div">
          {/* <span className="subtitle">Our Partner in</span> */}
          <span className="main-title">
            Turning Complex Ideas Into Software
          </span>
        </div>

        <p className="hero-description">
          All great products come with a problem and a moment of frustration.
          Maybe the system is too buggy, or the process proves too unreliable,
          or the idea just exists in writing. This is also where our story
          begins, and where yours does too. Here at Quad Theory Ltd, we assist
          ambitious teams in overcoming the hurdles of uncertainty by providing
          offshore software development in Bangladesh.
        </p>

        <p className="hero-call-to-action">
          We listen, design with intention, and create technology that works in
          the background to help your venture move forward with clarity.
        </p>

        <Link to="contact-us">
          <button className="contact-button">CONTACT US</button>
        </Link>
      </div>

      <div className="cards">
        {/* Row 1 */}
        <div className="cards_row">
          <div className="stat-box top-box box-1">
            <div className="stat-number">10+</div>
            <div className="stat-label">Industries Worked with</div>
          </div>
          <div className="stat-box bottom-box box-2">
            <div className="stat-number">30+</div>
            <div className="stat-label">Technologies & Frameworks</div>
          </div>
        </div>

        {/* Row 2 */}
        <div className="cards_row">
          <div className="stat-box top-box box-3">
            <div className="stat-number">5+</div>
            <div className="stat-label">Services Provided</div>
          </div>
          <div className="stat-box bottom-box box-4">
            <div className="stat-number">UK & Bangladesh</div>
            <div className="stat-label">Our Office</div>
          </div>
        </div>
        <div className="box-bg"></div>
      </div>
    </div>
  );
};

export default HeroSection;
